import Vue from 'vue'

 function filter(text, length, clamp){
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

function toMagazin(num){
    if(num === 80){
      return 'Expressen'
    }
    else if(num === 83){
      return 'Aftonbladet'
    }
    
}

Vue.filter('ledgerToString', toMagazin)
Vue.filter('truncate', filter)